import { ProductListItemUI } from './ProductListItemUI'
import { useProductListItem } from './useProductListItem'

interface ProductListItemProps {
  product: any
  className?: string
  variant?: 'grid' | 'list'
  isLargeCard?: boolean
}

export const ProductListItem = ({ product, variant, isLargeCard }: ProductListItemProps) => {
  const productListItemProps = useProductListItem({ product })

  return <ProductListItemUI product={product} {...productListItemProps} variant={variant} isLargeCard={isLargeCard} />
}
